import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const ContentItemsReducer = CreateGenericReducer(constructs["content-item"]);
